import React from 'react'

import { useFontSize } from '@hooks/useFontSize'

import FontSize from './FontSize'

export type FontSizeButtonInfoType = {
  size: string
  label: string
  className: string
}
const fontSizeButtonInfo: FontSizeButtonInfoType[] = [
  {
    size: 'small',
    label: '80%',
    className: 'text-lg',
  },
  {
    size: 'base',
    label: '100%',
    className: 'text-2xl',
  },
  {
    size: 'large',
    label: '125%',
    className: 'text-[32px]',
  },
]
const FontSizeContainer = () => {
  const [fontSize, setFontSize] = useFontSize()
  const props = {
    fontSizeButtonInfo,
    fontSize,
    setFontSize,
  }
  return <FontSize {...props} />
}

export default React.memo(FontSizeContainer)
